import type { OrderRecord } from '../../types/orders';
import { orderNumberLabel } from './orderNumberLabel';
import styles from './OrderNumberChip.module.css';

interface Props {
  order: Pick<OrderRecord, 'id' | 'sage_order_no' | 'status'>;
}

/** The Sage order number on an Orders row, or a plain "no number yet" state. */
export default function OrderNumberChip({ order }: Props) {
  const label = orderNumberLabel(order);
  const kindClass =
    label.kind === 'numbered' ? styles.numbered : label.kind === 'draft' ? styles.draft : styles.pending;
  return (
    <span
      className={`${styles.chip} ${kindClass}`}
      data-testid={`orders-list-order-no-${order.id}`}
      data-order-no-kind={label.kind}
      title={label.title}
    >
      {label.kind === 'numbered' && <span className={styles.prefix}>Order</span>}
      {label.text}
    </span>
  );
}
